module.exports = __webpack_public_path__ + "img/cta_mobile.bd70b0ce.png";